import { _ as r } from "../internals/export.js";
import { f as t } from "../internals/function-uncurry-this.js";
import { t as i } from "../internals/to-integer-or-infinity.js";
import { t as n } from "../internals/this-number-value.js";
import { s as o } from "../internals/string-repeat.js";
import { m as a } from "../internals/math-log10.js";
import { f as e } from "../internals/fails.js";
var s = RangeError,
  f = String,
  m = isFinite,
  l = Math.abs,
  u = Math.floor,
  p = Math.pow,
  c = Math.round,
  h = t(1..toExponential),
  g = t(o),
  j = t("".slice),
  v = "-6.9000e-11" === h(-.000000000069, 4) && "1.25e+0" === h(1.255, 2) && "1.235e+4" === h(12345, 3) && "3e+1" === h(25, 0);
r({
  target: "Number",
  proto: !0,
  forced: !v || !(e(function () {
    h(1, 1 / 0);
  }) && e(function () {
    h(1, -1 / 0);
  })) || !!e(function () {
    h(1 / 0, 1 / 0), h(NaN, 1 / 0);
  })
}, {
  toExponential: function toExponential(r) {
    var t = n(this);
    if (void 0 === r) return h(t);
    var o = i(r);
    if (!m(t)) return String(t);
    if (o < 0 || o > 20) throw s("Incorrect fraction digits");
    if (v) return h(t, o);
    var e = "",
      d = "",
      M = 0,
      b = "",
      x = "";
    if (t < 0 && (e = "-", t = -t), 0 === t) M = 0, d = g("0", o + 1);else {
      M = u(a(t));
      var E = 0,
        N = p(10, M - o);
      E = c(t / N), 2 * t >= (2 * E + 1) * N && (E += 1), E >= p(10, o + 1) && (E /= 10, M += 1), d = f(E);
    }
    return 0 !== o && (d = j(d, 0, 1) + "." + j(d, 1)), 0 === M ? (b = "+", x = "0") : (b = M > 0 ? "+" : "-", x = f(l(M))), e + (d += "e" + b + x);
  }
});